const updateTeamInSlack = async (_, args, context) => {
  const {
    teamId,
    channelId,
    usergroupHandle
  } = args;
  const url = `${context.url.stargateRoot}/teamsslack/api/team/${teamId}?channel=${channelId}&groupName=${usergroupHandle}`;
  return context.fetch(url, {
    method: 'POST'
  }).then(data => data.json()).then(data => ({
    id: teamId,
    // this helps to update cache easily
    ...data
  }));
};
export default updateTeamInSlack;